import type { Components } from "react-markdown";

import { cn } from "@alaffia-technology-solutions/tailwind-utils";

export const H2: Components["h2"] = ({ children, className, ...rest }) => (
  <h2
    className={cn("af-m-0 af-pt-6 af-text-xl af-font-bold", className)}
    {...rest}
  >
    {children}
  </h2>
);
